import React, { useState } from "react";
import { IEpiProps, PlansForLearner } from "../models/ilp-page-models";
import { useILPPageContext } from "../reducers/ilp-page-reducers";
import { PlanForLearnerDisplay } from "./plan-for-learner-display";


interface IProps {
    plansForLearner: PlansForLearner;
}

interface IContextProps {
    epiProps: IEpiProps;
}

export const PlansForLearnerDisplay = (props: IProps) => {
    const { epiProps }: IContextProps = useILPPageContext();

    return (
        <div className="ilp-card-wrapper">
            <h3 className="ilp-card-header">
               {props.plansForLearner.learnerFirstName} {props.plansForLearner.learnerLastName}
            </h3>
            
                {
                    props.plansForLearner && props.plansForLearner.plans &&
                    props.plansForLearner.plans.map(p =>
                        <PlanForLearnerDisplay planForLearner={p} />)
                }
           
        </div>

    );
}